import React from "react"
import t from "../translate";

//Op edu wordt alleen panel 2 (de programma-landingspages) gebruikt.
//Scherm 1, 3, 4, 5 en 'Score uitslagen' horen bij de oude standaardflow
//en zijn op edu niet meer toegankelijk.
const NavBar = ({ activeTab, setActiveTab }) => {

   return (
   <nav className="navbar navbar-intervention-settings navbar-expand-lg navbar-light bg-light">
      <div id="navbarNavAltMarkup">
        <div className="navbar-nav">

          <span id="settings-navbar-general"
            className={activeTab == "panel2" ? "nav-item nav-link active" : "nav-item nav-link"}
            onClick={() => { setActiveTab("panel2") }}
          >
            {t("Landingspages")}
          </span>

        </div>
      </div>
   </nav>
   )
}

export default NavBar
